import React, { Component } from 'react';

class ModalServices extends Component {

  serviceTotal(service){
    if (service.price && service.quantity){
      if (service.preview && service.preview.preview_required){
        return (service.price + service.preview.price) * service.quantity;
      } else {
        return service.price * service.quantity;
      }
    }
    return 0;
  }

  render() {
    if (!this.props.inquiry) return <div className="alert alert-danger">No Inquiry Loaded</div>;
    return (
    	<React.Fragment>
            <table className="table">
                <thead>
                    <tr>
                        <th>Service</th>
                        <th>Quantity</th>
                        <th>Price</th>
                        <th>Total Price</th>
                    </tr>
                </thead>
                <tbody>
            {this.props.inquiry.service_list.map((service, service_index) =>
                <tr key={service_index}>
                    <td className="">{service.name}{service.preview && service.preview.preview_required ? <React.Fragment><br/><span style={{fontSize:10+"px"}} className="">{service.preview.name} - this service required and will be added automatically to your quantity.</span></React.Fragment> : null}</td>
                    <td className="">{service.quantity}</td>
                    <td className="">${service.price}</td>
                    <td className="">${this.serviceTotal(service)}</td>
                </tr>
            )}
                </tbody>
            </table>
            <div className="pull-right">
                <h5 style={{"text-align":"right"}}>Hair Total: ${this.props.inquiry.service_total_breakdown[1]}</h5>
                <h5 style={{"text-align":"right"}}>Makeup Total: ${this.props.inquiry.service_total_breakdown[2]}</h5>
                <h3 style={{"text-align":"right"}}>Service Total: ${this.props.inquiry.service_total}</h3>
            </div>
        </React.Fragment>
    )
  }
}

export default ModalServices;



// WEBPACK FOOTER //
// ./src/components/business/ModalServices.js